module.exports = __webpack_public_path__ + "img/77.30496bc1.png";